module.exports = __webpack_public_path__ + "img/yml_gallery5.e8b08458.jpg";